import type { Flag } from './ClientServerGraph.types';

export const formatFlags = (
  firstPaint?: number,
  contentPaint?: number,
  pageInteractive?: number
): Array<Flag> => {
  const formattedFlags = [
    {
      id: 'pageInteractive',
      label: 'Page\nInteractive',
      time: pageInteractive,
      stackIndex: 0,
    },
    {
      id: 'contentPaint',
      label: 'Content\nPainted',
      time: contentPaint,
      stackIndex: 0,
    },
    {
      id: 'firstPaint',
      label: 'First\nPaint',
      time: firstPaint,
      stackIndex: 0,
    },
  ].filter((flag) => typeof flag.time === 'number') as Array<Flag>;

  // By default, all flags have a stackIndex of 0, but
  // we want to increment them by 1 for every flag
  // at exactly the same time (or, TODO, +/- a small
  // amount?)

  formattedFlags.forEach((flag, flagIndex) => {
    for (let i = 0; i < flagIndex; i++) {
      const flagToCompare = formattedFlags[i];

      if (flag.time === flagToCompare.time) {
        flag.stackIndex += 1;
      }
    }
  });

  return formattedFlags;
};

export const getNumOfStackedFlags = (
  formattedFlags: Array<Flag>
): number => {
  let highestStackIndex = 0;

  formattedFlags.forEach((flag) => {
    if (flag.stackIndex > highestStackIndex) {
      highestStackIndex = flag.stackIndex;
    }
  });

  return highestStackIndex;
};
